import { useQuery } from "react-query";
import { fetcher } from "@weezevent/weezjs-core";
import useOrganizationContext from "../../hooks/useOrganizationContext";

const getEventStats = (organizationId, params) => {
	return fetcher.get(`/bo/organizers/${organizationId}/events/stats/`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});
};

const useEventStats = ({ params = null, options = {} } = {}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	params = {
		ordering: "-pk",
		is_closed: "None",
		...params
	};

	return useQuery(
		["event-stats", organizationId, params],
		() => getEventStats(organizationId, params).then(response => response),
		{
			...options,
			enabled: (options?.enabled ?? true) && Boolean(organizationId),
			select: data => data.response // [{id, attendees_count}]
		}
	);
};

export default useEventStats;
